import React from 'react';
import accounting from "accounting";
import moment from "moment/moment";
import {ADVANCE_DISBURSEMENTS_TRANSITIONAL_STATUS, CURRENCY, LEGAL_ADVICE_TEXT, POLICYHOLDER_TEXT, TABLE_VIEW_OPTIONS} from "../../helpers/variables";
import Autosuggest from "react-autosuggest";
import CustomTextInput from "../General/customTextInput";
import '../../style/advanceDisbursementsList.css'
import Button from "../button";
import MultiSelectInput from "../General/multiSelectInput";
import {isAragUser} from "../../helpers/functions";
import AdvanceDisbursementsOverviewTable from "./advanceDisbursementsOverviewTable";
import CustomTable from "../General/customTable/CustomTable";
import CenteredDots from "../General/centeredDots";

const url = "/application-and-policies/application-policy/";

const columns = [
    {propertyName: "aragReference", header: "Policy Number"},
    {propertyName: "clientName", header: `${POLICYHOLDER_TEXT} Name`},
    {propertyName: "expenseTypeName", header: "Disbursement Type"},
    {propertyName: "amount", header: "Amount", formatter: (row) => accounting.formatMoney(row.amount, `${CURRENCY}`, 2)},
    {propertyName: "disbursementStatusName", header: "Status", formatter: (ad => (
            ad.paymentInstructionId && ad.disbursementStatusMachineName === "approved" ?
                ADVANCE_DISBURSEMENTS_TRANSITIONAL_STATUS
                :
                ad.disbursementStatusName
        ))},
    {propertyName: "creationDate", header: "Date Created", formatter: (row) => moment(row.creationDate).format("DD/MM/YYYY")},
    {propertyName: "paymentDate", header: "Date Paid", formatter: (row) => (row.paymentDate? moment(row.paymentDate).format("DD/MM/YYYY") : "")},
    { propertyName: "paymentInstructionId", header: "Payment Reference", formatter: (row) => (row.paymentInstructionId ? row.paymentInstructionId : '')},
];

const AdvancedDisbursementsList = (props) => {
    const {
        caseTypes,
        fetchingCaseTypes,
        lawsysFirms,
        fetchingLawsysFirms,
        filterByStatusOptions,
        changeStoreSettings,
        loggedInUserRoles,
        subCaseTypes,
        clearFilters,
        totalNumberOfAdvancedDisbursements,
        totalNumberOfApplied,
        totalNumberOfApproved,
        totalValueOfAdvancedDisbursements,
        totalValueOfApplied,
        totalValueOfApproved,
        totalSettledRecords,
        totalSettledValue,
        totalRejectedRecords,
        totalRejectedValue,
        totalProcessingRecords,
        totalProcessingValue,
        totalPaidRecords,
        totalPaidValue,
        fetchingADDueForPayment,
        totalPartSettledRecords,
        totalPartSettledValue
    } = props;
    return (
        <div className={"advance-disbursements-wrapper"}>
            <div className="row">
                <h2 className="col-sm-12 applicationsAndPolicies-h2 advance-disbursements-header">
                    Advance Disbursements
                </h2>
            </div>
            {isAragUser(loggedInUserRoles) && (
                <div className={"row"}>
                    <div className={"col-sm-12 mb-15"}>
                        <AdvanceDisbursementsOverviewTable
                            totalNumberOfAdvancedDisbursements={totalNumberOfAdvancedDisbursements}
                            totalNumberOfApplied={totalNumberOfApplied}
                            totalNumberOfApproved={totalNumberOfApproved}
                            totalSettledRecords={totalSettledRecords}
                            totalValueOfAdvancedDisbursements={totalValueOfAdvancedDisbursements}
                            totalValueOfApplied={totalValueOfApplied}
                            totalValueOfApproved={totalValueOfApproved}
                            totalSettledValue={totalSettledValue}
                            totalRejectedRecords={totalRejectedRecords}
                            totalRejectedValue={totalRejectedValue}
                            totalProcessingRecords={totalProcessingRecords}
                            totalProcessingValue={totalProcessingValue}
                            totalPaidRecords={totalPaidRecords}
                            totalPaidValue={totalPaidValue}
                            totalPartSettledRecords={totalPartSettledRecords}
                            totalPartSettledValue={totalPartSettledValue}
                            isAragUser={isAragUser(loggedInUserRoles)}
                        />
                    </div>
                </div>
            )}
            <form className="form-horizontal">
                {isAragUser(loggedInUserRoles) && (
                    <MultiSelectInput
                        closeMenuOnSelect={false}
                        isLoading={fetchingLawsysFirms}
                        labelClassName={'col-sm-2'}
                        label={`${LEGAL_ADVICE_TEXT} firms`}
                        inputClassName={'col-sm-7'}
                        isMulti={true}
                        placeholder={'Quick search'}
                        handleInputChange={(values) => changeStoreSettings({
                            key: "selectedFirms",
                            value: values
                        })}
                        value={props.advancedDisbursementsList.selectedFirms}
                        options={lawsysFirms.map(firm => ({value: firm.id, label: firm.name}))}
                    />
                )}
                <MultiSelectInput
                    closeMenuOnSelect={false}
                    isLoading={fetchingCaseTypes}
                    labelClassName={'col-sm-2'}
                    label={'Case Types'}
                    inputClassName={'col-sm-7'}
                    isMulti={true}
                    placeholder={'Quick search'}
                    handleInputChange={(values) => changeStoreSettings({
                        key: "selectedCaseTypes",
                        value: values
                    })}
                    value={props.advancedDisbursementsList.selectedCaseTypes}
                    options={caseTypes.map(type => ({value: type.id, label: type.name, machineName: type.machineName}))}
                />
                {(subCaseTypes.length > 0 || props.advancedDisbursementsList.selectedSubCaseTypes.length > 0) && (
                    <MultiSelectInput
                        closeMenuOnSelect={false}
                        isLoading={fetchingCaseTypes}
                        labelClassName={'col-sm-2'}
                        label={'Sub Case Types'}
                        inputClassName={'col-sm-7'}
                        isMulti={true}
                        placeholder={'Quick search'}
                        handleInputChange={(values) => changeStoreSettings({
                            key: "selectedSubCaseTypes",
                            value: values
                        })}
                        value={props.advancedDisbursementsList.selectedSubCaseTypes}
                        options={subCaseTypes}
                    />
                )}
                <MultiSelectInput
                    closeMenuOnSelect={false}
                    isLoading={fetchingCaseTypes}
                    labelClassName={'col-sm-2'}
                    label={'Statuses'}
                    inputClassName={'col-sm-7'}
                    isMulti={true}
                    placeholder={'Quick search'}
                    handleInputChange={(values) => changeStoreSettings({
                        key: "selectedStatuses",
                        value: values
                    })}
                    value={props.advancedDisbursementsList.selectedStatuses}
                    options={filterByStatusOptions}
                />
                <div className="form-group">
                    <div className="col-sm-2">
                        <label className={'control-label.text-left formGroupSelectInput-label'}>
                            {"Search"}
                        </label>
                    </div>
                    <div className="col-sm-7"
                         onKeyPress={(evt) => null}
                    >
                        <Autosuggest
                            suggestions={props.advancedDisbursementsList.suggestions}
                            onSuggestionsFetchRequested={props._onSuggestionsFetchRequested}
                            onSuggestionsClearRequested={props._onSuggestionsClearRequested}
                            getSuggestionValue={props._getSuggestionValue}
                            renderSuggestion={props._renderSuggestion}
                            inputProps={props.autoSuggesetInputProps}
                            onSuggestionSelected={props._onAdSuggestionSelected}
                            theme ={{
                                container: 'agents-list-action-autoSuggest-container',
                                input:'applicationsAndPolicies-autosuggest',
                                suggestionsContainer: 'applicationsAndPolicies-autosuggest-suggestionsContainer',
                                suggestionsList: 'applicationsAndPolicies-autosuggest-suggestionsList',
                                suggestion: 'applicationsAndPolicies-autosuggest-suggestion',
                                suggestionHighlighted:'applicationsAndPolicies-autosuggest-suggestion-highLighted'
                            }}
                        />
                        <div className="applicationsAndPolicies-autosuggest-search-icon"
                             onClick={props._handleAutosuggestButton}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title>Asset 6</title>
                                <g id="Layer_2" data-name="Layer 2">
                                    <g id="info">
                                        <path
                                            d="M15.61,13.72l-3.48-3.48-.06,0a6.58,6.58,0,1,0-1.88,1.88l0,.06,3.48,3.48a1.34,1.34,0,0,0,1.89-1.89Zm-9-2.84a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,6.58,10.88Z"/>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className="advance-disbursements-amount-range mb-15">
                    <span>Amount From:</span>
                    <CustomTextInput
                        wrapper={'advance-disbursements-amount-range__text-inputs'}
                        Type={'number'}
                        min={0.00}
                        step={0.01}
                        Name={'amountFrom'}
                        Value={props.advancedDisbursementsList.amountFrom}
                        HandleInputChange={props._handleInputChange}
                    />
                    <span>To:</span>
                    <CustomTextInput
                        wrapper={'advance-disbursements-amount-range__text-inputs'}
                        Type={'number'}
                        min={0.00}
                        step={0.01}
                        Name={'amountTo'}
                        Value={props.advancedDisbursementsList.amountTo}
                        HandleInputChange={props._handleInputChange}
                    />
                    <Button clickHandler={props._filterByRange} wrapper="btn-wrapper"
                            btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                            label="Filter"/>
                    <Button clickHandler={clearFilters} wrapper="btn-wrapper"
                            btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
                            label="Clear Filter"
                    />
                    <Button
                        disabled={(
                            isAragUser(loggedInUserRoles)
                            && (
                                props.advancedDisbursementsList.selectedFirms.length !== 1
                            )
                        )}
                        clickHandler={props.onPrintStatement}
                        wrapper="btn-wrapper"
                        btnType="button"
                        btnStyle={'btn btn-primary btn-xs sharp blue'}
                        label="Download Statement"
                        title={isAragUser(loggedInUserRoles) ? `Select an individual ${LEGAL_ADVICE_TEXT.toLowerCase()} firm in order to print a statement` : null}
                    />
                    {fetchingADDueForPayment && (
                        <CenteredDots/>
                    )}
                </div>
            </form>
            <div className="row">
                <div className="col-sm-12">
                    <CustomTable
                        accordionItemHeaderFormatter={(row) => (
                            `Policy Number: ${row.aragReference} Disbursement Type: ${row.expenseTypeName}`
                        )}
                        onPageSizeChange={props._changeTableViewOptions}
                        goAtPage={props._changeAdvancedDisbursementsPage}
                        onPageShift={props._shiftAdTablePage}
                        loading={props.fetchingAdvancedDisbursements}
                        fixed
                        responsive
                        striped
                        columns={columns}
                        data={props.advancedDisbursements}
                        pageSize={props.advancedDisbursementsList.viewAmount}
                        totalRecords={props.advancedDisbursementsList.totalRecords}
                        totalPages={props.advancedDisbursementsList.totalPaginationBoxes}
                        page={parseInt(props.advancedDisbursementsList.page)}
                        hasActions
                        actions={[
                            {
                                key: 'details',
                                label: 'Details',
                                handleRedirect: (row) => url + row.applicationId + "/advanceDisbursements"
                            },
                        ]}
                        pageSizeOptions={TABLE_VIEW_OPTIONS}
                    />
                </div>
            </div>
        </div>
    )
};

export default AdvancedDisbursementsList;